import {
  Component,
  DestroyRef,
  ElementRef,
  inject,
  Input,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'ez-checkbox-input',
  imports: [ReactiveFormsModule],
  templateUrl: './checkbox-input.component.html',
  styleUrl: './checkbox-input.component.scss',
})
export class CheckboxInputComponent implements OnInit, OnChanges {
  private rootFormGroup = inject(FormGroupDirective);
  private destroyRef = inject(DestroyRef);

  @Input() isDisabled = false;
  @Input() name: string;
  @Input() controlName: string;
  @ViewChild('checkbox') input: ElementRef<HTMLInputElement>;
  form: FormGroup;

  readonly errorMessage = signal<string | null>(null);

  get control(): AbstractControl {
    return this.form.get(this.controlName)!;
  }

  private currentErrorMessage(): string | null {
    const control = this.control;
    if (!control.invalid || !(control.dirty || control.touched)) {
      return null;
    }
    if (control.errors?.['required']) {
      return 'Fehler: Dies ist ein Pflichtfeld.';
    }
    return 'Fehlerhafte Eingabe.';
  }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control;
    this.control.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.errorMessage.set(this.currentErrorMessage()));
    this.updateDisabled();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isDisabled']) {
      this.updateDisabled();
    }
  }

  updateDisabled(): void {
    const control = this.control;
    if (this.isDisabled) {
      control.disable();
    } else {
      control.enable();
    }
  }
}
